let lastAgentCartSync: CartUpdatePayload[] | null = null;

export const getLastAgentCartSync = (): CartUpdatePayload[] | null => lastAgentCartSync;

export const publishAgentCartSync = (items: CartUpdatePayload[]): void => {
  lastAgentCartSync = items;
  window.dispatchEvent(new CustomEvent('google-agent-cart-updated', { detail: items }));
};
